import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { createContext, type ReactNode, useContext } from "react";

export const RebrandContext = createContext(false);

/**
 * Returns whether the rebrand is active.
 * Use this for any rebrand-conditional logic: logos, images, component variants, theme selection.
 */
export function useIsRebrand(): boolean {
  return useContext(RebrandContext);
}

/**
 * Reads the WORKPLACE_APP_REBRAND_ENABLED feature flag and provides
 * the result via context. Must be placed inside the LaunchDarkly provider
 * and above any component that calls useIsRebrand().
 */
export function RebrandProvider(props: { children: ReactNode }) {
  const isNewNavEnabled = useCbhFlag(CbhFeatureFlag.ADMIN_APP_NAVIGATION_REDESIGN_ENABLED, {
    defaultValue: false,
  });

  const isRebrandEnabled = useCbhFlag(CbhFeatureFlag.WORKPLACE_APP_REBRAND_ENABLED, {
    defaultValue: false,
  });

  return (
    <RebrandContext.Provider value={isRebrandEnabled && isNewNavEnabled}>
      {props.children}
    </RebrandContext.Provider>
  );
}
